// extracted by mini-css-extract-plugin
export default {"wrapper":"Bz-z","button":"Cz-z","alternate":"Dz-z","disabled":"Ez-z","paymentWarning":"Fz-z","fadeIn":"Gz-z"};